import InboundFollowUpRequirementDocument from "./InboundFollowUpRequirementDocument";

export default class InboundRedemptionFollowUp {
    constructor(json) {

        this.id = json["id"];
        this.userId = json["user-id"];
        this.redemptionRequestId = json["redemption-request-id"];
        this.dateCreated = json["date-created"];
        this.reason = json["reason"];
        this.status = json["status"];
        this.requirements = [];
        this.requiresSigningOfReportingDeclaration = json["requires-signing-of-reporting-declaration"];
        this.reportingDeclarationVersion = json["reporting-declaration-version"];
        let requirements = json["requirements"];
        requirements.forEach(singleRequirement => {
            this.requirements.push(new InboundFollowUpRequirementDocument(singleRequirement))
        });
    }
}


